import styled from '@emotion/styled';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { withConfig } from 'src/withConfig';

export const GamblingSafetyTopBarWrapper = withConfig(theme => styled('div', { label: 'GamblingSafetyTopBarWrapper' })`
    align-items: center;
    background-color: ${theme.star.gamblingSafetyTopBar.bgColor};
    display: flex;
    height: 40px;
    overflow: hidden;
    width: 100%;
`);

export const GamblingSafetyScrollableContent = styled('div', { label: 'GamblingSafetyScrollableContent' })`
    flex: 1;
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
    scroll-padding-inline: 12px;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const GamblingSafetyScrollableInner = styled('div', { label: 'GamblingSafetyScrollableInner' })`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    gap: 32px;
    justify-content: center;
    min-width: 100%;
    padding: 0 12px;
    width: max-content;
`;

export const GamblingSafetyLink = withConfig(theme => styled('a', { label: 'GamblingSafetyLink' })`
    align-items: center;
    color: ${theme.star.gamblingSafetyTopBar.txtColor};
    display: flex;
    flex-shrink: 0;
    position: relative;
    &::after {
        background: ${theme.star.gamblingSafetyTopBar.bgColorSecondary};
        content: '';
        height: 12px;
        inset: 0 auto 0 100%;
        margin: auto 0 auto 16px;
        position: absolute;
        width: 1px;
    }
    &:last-of-type {
        &::after {
            content: none;
        }
    }
`);

export const ManageLimitsLink = withConfig(theme => styled(Link, { label: 'ManageLimitsLink' })`
    align-items: center;
    background-color: ${theme.star.gamblingSafetyTopBar.bgColorTertiary};
    border-radius: ${theme.star.radius.small};
    box-sizing: border-box;
    color: ${theme.star.gamblingSafetyTopBar.txtColorSecondary};
    display: inline-flex;
    flex-shrink: 0;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    height: 24px;
    margin: 0 12px 0 8px;
    padding: 0 12px;
    text-decoration: none;
    white-space: nowrap;
`);
